import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll position to the top of the page whenever the route changes.
// React Router does not do this automatically, so navigating to a long page
// could otherwise leave you partway down it.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
